import { useDispatch, useSelector } from 'react-redux';
import { editProp } from 'state/fence/fenceSlice';
import { getFenceGroupDetails, getBrickCounts, getBrickColor } from 'state/fence/fenceSelector';
import { openModal } from 'state/modal/modalSlice';
import { currentBrick } from 'helpers/globals';
import ButtonBase from 'components/common/ButtonBase/ButtonBase';
import style from './AppHeader.module.scss';

const AppHeader = () => {
  const dispatch = useDispatch();
  const readyForCalculation = useSelector((state) => state.fence.readyForCalculation);
  const fenceDetails = useSelector(getFenceGroupDetails);
  const brickCounts = useSelector(getBrickCounts(fenceDetails));
  const brickColor = useSelector(getBrickColor);

  const openFullViewModal = () => {
    dispatch(openModal('full-view'));
  };

  const openCalculation = () => {
    dispatch(editProp({ prop: 'readyForCalculation', value: true }));
  };

  const closeCalculation = () => {
    dispatch(editProp({ prop: 'readyForCalculation', value: false }));
  };

  return (
    <div className={style.header}>
      <div className={style.header_logos}>
        <a href="https://fruehwald.hu/" target="_blank" rel="noreferrer">
          <img src="./logo-fruhwald.svg" alt="Frühwald logo" />
        </a>
        <img src="./logo.svg" alt="KerítésTervező logo" />
      </div>

      {readyForCalculation && <h1 className={style.header_title}>Megtervezett kerítés kalkulációja</h1>}

      {!readyForCalculation && (
        <ul className={style.header_elements}>
          <li>
            <img src={brickColor.normal} alt="" />
            <div>
              normálkő
              <br />
              {currentBrick.normalBrick.width} x {currentBrick.normalBrick.depth} x {currentBrick.normalBrick.height} cm
              <strong>{brickCounts.normal} db</strong>
            </div>
          </li>
          <li>
            <img src={brickColor.half} alt="" />
            <div>
              félkő
              <br />
              {currentBrick.halfBrick.width} x {currentBrick.halfBrick.depth} x {currentBrick.halfBrick.height} cm
              <strong>{brickCounts.half} db</strong>
            </div>
          </li>
          <li>
            <img src={brickColor.topCover} alt="" />
            <div>
              fedőlap
              <br />
              {currentBrick.topCover.width} x {currentBrick.topCover.depth} x {currentBrick.topCover.height}/
              {currentBrick.topCover.height - 1} cm
              <strong>{brickCounts.topCover} db</strong>
            </div>
          </li>
        </ul>
      )}

      {readyForCalculation ? (
        <ul className={style.header_buttons}>
          <li>
            <ButtonBase onClick={closeCalculation}>Vissza a kerítéstervezőhöz</ButtonBase>
          </li>
        </ul>
      ) : (
        <ul className={style.header_buttons}>
          <li>
            <ButtonBase onClick={openFullViewModal}>Teljes nézet</ButtonBase>
          </li>
          <li>
            <ButtonBase color="primary" onClick={openCalculation}>
              Kalkuláció
            </ButtonBase>
          </li>
        </ul>
      )}
    </div>
  );
};

export default AppHeader;
